export class SentBidInfo {
  constructor(public isFinal?: boolean, public signature?: string) {}
}
